import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Retiring from './icon-retiring.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Retiring {...validProps} />;
}
SvgComponent.iconName = 'retiring';

/**
 * @deprecated This is a legacy icon
 */
export const RetiringIcon = svgIconWrapper(SvgComponent);
